import { author as authorData, authorTypes as authorTypesData } from "~/data";

export const isSCMPEditorial = (authorIds: string[]) =>
  authorIds?.includes(authorData.scmpEditorial.entityId);

export const isSCMPPR = (authorIds: string[]) => authorIds?.includes(authorData.scmpPR.entityId);

export const isSCMPColumnist = (authorTypes?: ReadonlyArray<Nullish<string>> | null) =>
  authorTypes?.includes(authorTypesData.ScmpColumnist);
